// extracted by mini-css-extract-plugin
export default {"container":"_styles_container__+kBPj","link":"_styles_link__pNZAn","link__partTime":"_styles_link__partTime__WKj14","link__fullTime":"_styles_link__fullTime__vN32K"};